// Externe Bibliotheken
import { useNavigate } from 'react-router';
import { useEffect } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { globalParams } from '@/_config/globalParams';

export const AutoLogout = ({ children }) => {
    const navigate = useNavigate();
    let autoLogoutTime = globalParams.autoLogoutTime;
    const specialLogout = storage.get('autoLogoutInsteadOfRefreshLogin');

    useEffect(() => {
        const logic = () => {
            if (storage.get('access_token') !== null) {
                let loginTime = storage.get('login_timestamp');
                let currentTime = new Date().getTime();
                let remainingTime = autoLogoutTime - (new Date().getTime() - storage.get('login_timestamp'));

                if (storage.get('setAutoLogoutTimer')) {
                    storage.set('setAutoLogoutTimer', true);
                }

                setTimeout(() => {
                    currentTime = new Date().getTime();
                    loginTime = storage.get('login_timestamp');
                    if (currentTime - loginTime >= autoLogoutTime) {
                        logout();
                    }
                }, remainingTime);
            }
        };
        logic();

        return () => {
            logic();
        };
    });

    const logout = () => {
        storage.clear();
        navigate('/login?autologout=true');
    };

    if (specialLogout) {
        autoLogoutTime = 0;
        logout();
    }

    return children;
};
